<label *ngIf="props.label">
    {{ getLabel() | htmlDecode }}
    <span *ngIf="props.required">*</span>
</label>
<ng-container #fieldComponent></ng-container>